var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M9 3V0H0v9h3v3h9V3H9zM3 8H1V1h7v2H3v5zm8 3H4V4h7v7z","fill":"#FF8D2E"}})])}
var staticRenderFns = []

export { render, staticRenderFns }